import { useUiStore } from '../../store/ui';
import { useDeleteYear, useYears } from '../../store/queryHooks';
import styles from './YearMenu.module.css';

interface Props {
  onOpenCopy: () => void;
}

export function YearMenu({ onOpenCopy }: Props) {
  const { year, openMenu, setYear, setOpenMenu, setToast } = useUiStore();
  const years = useYears();
  const del = useDeleteYear();
  const isOpen = openMenu === 'year';

  const options = years.data ?? [year];
  const canDelete = options.length > 1;

  async function onDeleteYear(y: number) {
    if (!window.confirm(`Slet hele året ${y}? Alle budget- og faktiske tal for året fjernes.`)) {
      return;
    }
    try {
      await del.mutateAsync(y);
      if (y === year) {
        const remaining = options.filter((o) => o !== y);
        if (remaining.length > 0) setYear(remaining[remaining.length - 1]!);
      }
      setToast(`År ${y} slettet`);
    } catch {
      setToast('Kunne ikke slette år');
    }
  }

  return (
    <div className={styles.wrap}>
      <button className={styles.trigger} onClick={() => setOpenMenu(isOpen ? null : 'year')}>
        <span className={styles.dot} />
        {year}
        <span className={styles.caret}>▾</span>
      </button>
      {isOpen && (
        <div className={styles.menu}>
          {options.map((y) => (
            <div key={y} className={styles.row}>
              <button
                className={`${styles.pick} ${y === year ? styles.selected : ''}`}
                onClick={() => setYear(y)}
              >
                {y}
              </button>
              {canDelete && (
                <button
                  className={styles.del}
                  title="Slet år"
                  onClick={(e) => {
                    e.stopPropagation();
                    onDeleteYear(y);
                  }}
                >
                  ✕
                </button>
              )}
            </div>
          ))}
          <div className={styles.sep} />
          <button
            className={styles.copy}
            onClick={() => {
              setOpenMenu(null);
              onOpenCopy();
            }}
          >
            + Kopiér til nyt år
          </button>
        </div>
      )}
    </div>
  );
}
